import { setDisplayedQFRequestTime } from '../actions/publicActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(setDisplayedQFRequestTime, function (actionMessage) {
    getStore().displayedQFRequestTime = actionMessage.displayedQFRequestTime;
});
//# sourceMappingURL=setDisplayedQFRequestTimeMutator.js.map